var axios = require('axios')

const getCountryAndIp = async () => {
  try {
    let { data } = await axios({
      url: 'https://ipapi.co/json',
      method: 'get'
    })

    return { type: '2', data: data }
  } catch (error) {
    try {
      let { data } = await axios({
        url: 'https://api.ip.sb/geoip?callback=',
        method: 'get'
      })

      return { type: '1', data: data }
    } catch (error) {
      try {
        let { data } = await axios({
          url: 'https://ipinfo.io',
          method: 'get',
          headers: {
            Host: 'ipinfo.io',
            'User-Agent': 'curl/7.83.1'
          }
        })

        return { type: '3', data: data }
      } catch (error) {
        return { type: '500' }
      }
    }
  }
}

const countryAndIp = async () => {
  let obj = {
    ip: '209.141.54.129',
    country: 'US',
    region: 'Nevada',
    city: 'Las Vegas',
    country_name: 'United States'
  }

  try {
    let localCountryAndIp = localStorage.getItem('localCountryAndIp')

    if (localCountryAndIp != null) {
      return JSON.parse(localCountryAndIp)
    }

    let res = await getCountryAndIp()

    if (res.type == '1') {
      obj.ip = res.data.ip
      obj.country = res.data.country_code
      obj.region = res.data.country
      obj.city = res.data.country
      obj.country_name = res.data.country
    } else if (res.type == '2') {
      obj.ip = res.data.ip
      obj.country = res.data.country
      obj.region = res.data.region != null ? res.data.region : res.data.city
      obj.city = res.data.city
      obj.country_name = res.data.country_name
    } else if (res.type == '3') {
      obj.ip = res.data.ip
      obj.country = res.data.country
      obj.region = res.data.region
      obj.city = res.data.city
      obj.country_name = res.data.country
    }

    if (res.type != '500') {
      localStorage.setItem('localCountryAndIp', JSON.stringify(obj))
    }

    return obj
  } catch (error) {
    return obj
  }
}

export default countryAndIp
